// 电损信息下载页面
import React, {
  Component,
} from "react";
import { Form, Select, Radio, Spin, Input, Button, message, Popover } from "antd";
import RichEditor from "@/components/display/richEditor";
import { updateStatusCodeInfo, getDicCodeList } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import { QuestionCircleOutlined } from "@ant-design/icons";
import "@/assets/stylus/addDownloadPage.styl";

const FormItem = Form.Item;
const { Option } = Select;
const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

class ErrorCodeConfig extends Component {
  constructor(props) {
    super(props);

    const levelOption = window.LayoutTab.tabParam.levelOption;
    this.props = props;
    this.state = {
      btnClicked: true, // 提交按钮是否可点 ： true：不可点，false:可点
      record: window.LayoutTab.tabParam.errorCodeInfo || {},
      levelOption: levelOption ? levelOption.filter((v) => v.value !== "") : [],
      reasonOption: [],
      triggerOption: [],
      defaultLvItem: levelOption.find((v) => v.text === "重大"),
      loading: false,
    };
  }

  // 设置Form的ref
  formRef = React.createRef()

  // 获取原因分类列表
  getReasonOption = () => {
    fetchHandler(getDicCodeList, {
      code: "maint.statuscode",
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          reasonOption: res.data,
        });
      }
    });
  }

  // 获取触发方列表
  getTriggerOption = () => {
    fetchHandler(getDicCodeList, {
      code: "maint.statustigger",
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          triggerOption: res.data,
        });
      }
    });
  }

  // 取消操作
  handleCancel = async () => {
    await this.props.onDelete("errorCodeConfig");
    this.props.onAdd({
      key: "9004",
      titleText: "状态码管理",
    });
  } /**
   * 点击提交按钮执行方法
  */

  submitForm = () => {
    this.setState({
      loading: true,
    });
    const info = this.formRef.current.getFieldsValue();
    console.log(info);
    fetchHandler(updateStatusCodeInfo, info).then((res) => {
      this.setState({
        loading: false,
      });
      if (res && res.code === "success") {
        message.success("配置成功！");
        this.handleCancel();
      }
    });
  }

  componentWillMount() {
    const { record } = this.state;
    this.getReasonOption();
    this.getTriggerOption();
    this.setState({
      isAlert: !record.isAlert || record.isAlert === "--" ? 0 : record.isAlert,
    });
  }

  // 空字符
  // requiredExcludesNullStr = (rule, value) => {
  //     if (value || value === '') {
  //         return Promise.resolve();
  //     }
  //     return Promise.reject();
  // }
  render() {
    const { record, levelOption, reasonOption, triggerOption } = this.state;

    const Content = (
      <Spin spinning={this.state.loading}>

        <div className="download-task-build-content error-code-config-container" style={{ width: "650px", padding: "24px" }}>
          <Form
            {...layout}
            ref={this.formRef}
          >
            {/* 指标类型 */}
            <div className='formTit'>基础定义</div>
            <div className='indicatorType'>
              <FormItem
                label='状态码'
                name='code'
                initialValue={record.code}
              >
                <Input disabled placeholder="状态码" />
              </FormItem>
              <FormItem
                label='状态名称'
                name='codeName'
                initialValue={record.codeName}
              >
                <Input disabled placeholder="状态名称" />
              </FormItem>
              <FormItem
                label='触发方'
                name='tiggerId'
                initialValue={!record.tiggerId || record.tiggerId === "--" ? "0" : record.tiggerId}
              >
                <Select onChange={this.changeDataDimention}>
                  {triggerOption.map((v) => (
                    <Option value={v.code}>{v.name}</Option>
                  ))}
                </Select>
              </FormItem>
              <FormItem
                label='是否告警'
                name='isAlert'
                initialValue={!record.isAlert || record.isAlert === "--" ? 0 : record.isAlert}
              >
                <Radio.Group onChange={(e) => { this.setState({ isAlert: e.target.value }); }}>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
              {/* 判断是否告警 isAlert */}
              <FormItem
                label='运维等级'
                name='levelId'
                initialValue={!record.levelId || record.levelId === "--" ? this.state.defaultLvItem.value : record.levelId}
              >
                <Select onChange={this.changeDataDimention}>
                  {levelOption.map((v) => (
                    <Option value={v.value}>{v.text}</Option>
                  ))}
                </Select>
              </FormItem>
              <FormItem
                label='是否影响充电'
                name='isCharging'
                initialValue={!record.isCharging || record.isCharging === "--" ? 0 : record.isCharging}
              >
                <Radio.Group>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
              <FormItem
                label='原因分类'
                wrapperCol={18}
              >
                <FormItem
                  name='statusTypeId'
                  initialValue={!record.statusTypeId || record.statusTypeId === "--" ? "0" : record.statusTypeId}
                  style={{ width: "351px", display: "inline-block" }}
                >
                  <Select onChange={this.changeDataDimention}>
                    {reasonOption.map((v) => (
                      <Option value={v.code}>{v.name}</Option>
                    ))}
                  </Select>
                </FormItem>
                <Popover title={null} content="分类涉及到充电成功率计算和停止原因分析，更改后新订单采用新的分类，历史订单不做修订。">
                  <QuestionCircleOutlined style={{ margin: "8px 0 0 5px" }} />
                </Popover>
              </FormItem>
              <FormItem
                label='是否属于异常停止'
                name='isErrorStop'
                initialValue={!record.isErrorStop || record.isErrorStop === "--" ? 0 : record.isErrorStop}
              >
                <Radio.Group>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
              <FormItem
                label='是否影响计费'
                name='isBilling'
                initialValue={!record.isBilling || record.isBilling === "--" ? 0 : record.isBilling}
              >
                <Radio.Group>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
              <FormItem
                label='是否影响状态'
                name='isEffectStubStatus'
                initialValue={!record.isEffectStubStatus || record.isEffectStubStatus === "--" ? 0 : record.isEffectStubStatus}
              >
                <Radio.Group>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </FormItem>
              <FormItem
                label='故障内容'
                name='desc'
                initialValue={!record.desc || record.desc === "--" ? null : record.desc}
              >
                <Input.TextArea disabled placeholder="故障内容" />
              </FormItem>
              <FormItem
                label='运维建议'
                name='maintMsg'
                initialValue={record && record.maintMsg && record.maintMsg !== "--" ? record.maintMsg : null}
              >
                <RichEditor
                  ref={(ref) => this.editRef = ref}
                  initialValue={record && record.maintMsg && record.maintMsg !== "--" ? record.maintMsg : null}
                  controls={[
                    "undo", "redo", "separator",
                    "font-size", "line-height", "letter-spacing", "separator", "bold",
                    // 'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
                    // 'superscript', 'subscript', 'remove-styles', 'emoji', 'separator',
                    // 'text-indent', 'text-align', 'separator',
                    // 'headings', 'list-ul', 'list-ol', 'blockquote', 'code', 'separator',
                    "link", "separator", "hr", "separator",
                  // 'separator',
                  // 'clear'
                  ]} />
                {/* <Input.TextArea placeholder="运维建议" /> */}

              </FormItem>
            </div>
          </Form>
          <div className='submitBtns'>
            <Button onClick={this.submitForm} type="primary"> 确定 </Button>
            <Button onClick={this.handleCancel}> 取消 </Button>
          </div>
        </div>
      </Spin>);

    return Content;
  }
}

export default ErrorCodeConfig;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/errorCodeManage/errorCodeConfig.js